<template>
  <component
    :is="link ? 'router-link' : 'div'"
    :to="link || null"
    class="c-listitem"
    :class="{ 'c-listitem--no-padding': noPadding }"
  >
    <div
      class="c-listitem__icon"
      :class="{
        'c-listitem__icon--light': iconStyle === 'logo',
        'c-listitem__icon--green': iconStyle === 'green'
      }"
      v-if="icon"
    >
      <o-icon :icon="icon" :keep-colors="iconStyle === 'logo' ? true : false" />
    </div>
    <div
      class="c-listitem__label"
      :class="{ 'c-listitem__label--green': labelStyle === 'green' }"
    >
      <slot name="label" />
      {{ $slots.label ? null : label }}
    </div>
    <div class="c-listitem__label-right" v-if="labelRight">
      {{ labelRight }}
    </div>
    <div class="c-listitem__chevron" v-if="chevron">
      <o-icon icon="chevron-right" />
    </div>
    <div class="c-listitem__action" v-if="hasActions">
      <slot name="action"> </slot>
    </div>
  </component>
</template>

<script>
// @group Base Components
export default {
  name: 'OListItem',
  props: {
    icon: {
      type: String,
      default: null
    },
    iconStyle: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    labelRight: {
      type: String
    },
    labelStyle: {
      type: String,
      default: null
    },
    link: {
      type: [String, Object],
      default: null
    },
    chevron: {
      type: Boolean,
      default: true
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasActions() {
      return !!this.$slots['action']
    }
  }
}
</script>

<style lang="scss">
.c-listitem {
  align-items: center;
  display: flex;
  min-height: 4.8rem;
  padding: 0 1.6rem;
}

.c-listitem--no-padding {
  padding: 0;
}

.c-listitem__icon {
  background: rgba($primary-color, 0.1);
  border-radius: 50%;
  color: $primary-color;
  color: var(--primary-color);
  display: flex;
  flex: none;
  margin-right: 1.6rem;
  padding: 0.8rem;
}

.c-listitem__icon--light {
  background-color: #fff;
  box-shadow: inset 0 0 0 0.1rem rgba(#000, 0.1);
  color: $primary-color;
  color: var(--primary-color);
}

.c-listitem__icon--green {
  background-color: rgba($green, 0.1);
  color: $green;
}

.c-listitem__label {
  flex: 1 1 0;
  font-size: 1.6rem;
  line-height: 2.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.c-listitem__label-right {
  color: $gray-700;
  font-size: 1.4rem;
}

.c-listitem__label--green {
  color: $green;
}

.c-listitem__chevron {
  flex: none;
  margin-left: auto;
  padding-left: 1.6rem;
}

.c-listitem__action {
  color: $primary-color;
  color: var(--primary-color);
  flex: none;
  margin-left: auto;
  padding-left: 1.6rem;
}
</style>
